import AuthEmobgConfig from "../configuration/auth-emobg-config";
import Cookies from "js-cookie";

export function clearAuthParams(): void {
    window.history.replaceState(
        {},
        document.title,
        window.location.pathname
    );
}

// eMobG is the only identity provider (plan §5.10). The cookie no longer
// selects between providers, but it still gates: getAccessToken() dereferences
// this without a null check, and relies on isValidAuthConfig() having been true
// first. Returning the config unconditionally would break that invariant.
export function getAuthConfig() {
    const provider = Cookies.get('backoffice');
    if (provider !== 'emobg') {
        return null;
    }
    return AuthEmobgConfig
}

export function setEmobgAuthConfig() {
    Cookies.set('backoffice', 'emobg', { secure: true, sameSite: 'none' });
}

export function removeAuthConfig() {
    Cookies.remove('backoffice');
}

export function isValidAuthConfig(): boolean {
    const provider = Cookies.get('backoffice');
    return provider === 'emobg'
}
